import * as i0 from "@angular/core";
export class StateStorageService {
    constructor() { }
    storeUrl(url) {
        sessionStorage.setItem('previousUrl', url);
    }
    getUrl() {
        return sessionStorage.getItem('previousUrl');
    }
}
StateStorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StateStorageService_Factory() { return new StateStorageService(); }, token: StateStorageService, providedIn: "root" });
